import manager from '@mailobj-browser/front/js/contracts/manager.js'
import text from '@mailobj-browser/front/js/fetchers/text.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import element from '@mailobj-browser/front/js/tree/element.js'
import invoke from '@mailobj-browser/front/js/tree/invoke.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import credentials from '#utilities/js/ea/credentials.js'
import { lock, unlock } from '../ea/cooldown.js'

const { entries } = Object

export const events = object(null, {
  load: 'template-load'
})

export const render = async (
  template,
  cooldown = false,
  params = template.dataset.url ? {} : null
) => {
  const { dataset, ownerDocument } = template
  const { url } = dataset
  const { defaultView } = ownerDocument
  const { location, CustomEvent, Request, URL } = defaultView
  const { href = location } = one('base', ownerDocument) ?? {}
  const clone = template.cloneNode(true)
  const { load } = events

  if (cooldown) {
    lock(ownerDocument)
  }

  if (url) {
    const rewritten = new URL(url, href)
    const { searchParams } = rewritten

    for (const [key, value] of entries(params)) {
      if ((value ?? null) !== null) {
        searchParams.set(key, `${value}`)
      }
    }

    const { fetched } = await text(object(null, {
      request: new Request(`${rewritten}`, {
        ...credentials(`${rewritten}`, ownerDocument)
      })
    }))

    clone.innerHTML = fetched
  }

  const { children: [detail] } = await invoke(clone)
  const body = element(ownerDocument, 'body')

  append(body, detail)
  await manager.trigger(body, template)

  if (body.contains(detail)) {
    remove(detail)
  }

  template.dispatchEvent(new CustomEvent(load, { detail }))

  if (cooldown) {
    unlock(ownerDocument)
  }

  return detail
}

